






















































































































import { Component, Vue } from 'vue-property-decorator';
import { LANGUAGE_MENU } from '@/constants/language-menu.constant';
import { setLanguage } from '@/i18n';
import { State, Getter, Mutation, Action } from 'vuex-class';
import { WidgetState } from '@/store/widget/types';
import { SUPPORTED_CURRENCIES } from '@resclick/data-access';

@Component
export default class TopBar extends Vue {
  @State('widget') widget!: WidgetState;
  @Getter('preferences/currency') currentCurrency!: string;
  @Action('cart/fetchCart') fetchCart!: () => void;
  @Mutation('preferences/setCurrency') setCurrency!: (currency: string) => void;
  currencies: any[] = [...SUPPORTED_CURRENCIES];
  languageMenu = LANGUAGE_MENU;

  get currency() {
    return this.currentCurrency;
  }

  set currency(value: string) {
    this.setCurrency(value);
    this.fetchCart();
  }

  get activeLanguage() {
    return LANGUAGE_MENU.find((lang) => lang.iso === this.$i18n.locale);
  }

  setLocale(value: string) {
    setLanguage(value);
    this.fetchCart();
  }
}
